import { Outlet } from 'react-router-dom';

import { usePermissions } from '../../auth/usePermissions.js';
import { useTranslation } from '../../i18n/useTranslation.js';

function NoAccess() {
  const { t } = useTranslation();
  return (
    <section className="page">
      <header className="page-header">
        <div>
          <h1>{t('access.denied.title')}</h1>
          <p className="muted">{t('access.denied.body')}</p>
        </div>
      </header>
    </section>
  );
}

/** Renders child routes only if the user can read the module; else a calm notice. */
export function ModuleGuard({ module }) {
  const { canRead } = usePermissions();
  if (!canRead(module)) {
    return <NoAccess />;
  }
  return <Outlet />;
}
